import { render, staticRenderFns } from "./PasswordDialog.vue?vue&type=template&id=1d53d88f&"
import script from "./PasswordDialog.vue?vue&type=script&lang=js&"
export * from "./PasswordDialog.vue?vue&type=script&lang=js&"
import style0 from "./PasswordDialog.vue?vue&type=style&index=0&id=1d53d88f&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VCol,VDialog,VDivider,VForm,VOverlay,VProgressCircular,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/fared/kowamas-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d53d88f')) {
      api.createRecord('1d53d88f', component.options)
    } else {
      api.reload('1d53d88f', component.options)
    }
    module.hot.accept("./PasswordDialog.vue?vue&type=template&id=1d53d88f&", function () {
      api.rerender('1d53d88f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/widgets/PasswordDialog.vue"
export default component.exports